module.exports = "<div class=\"preloader\"></div>\n"